import './App.css';
import Landing from './components/Landing';
import Client from './components/Client';
import Faq from './components/Faq';
import Testimonial from './components/Testimonial';
import Provide from './components/Provide';
import Footer from './components/Footer';
import ProductDetail from "./components/Pages/ProductDetail";
import { BrowserRouter as Router, Routes, Route} from "react-router-dom";
import ProductSection from './components/ProductPage/ProductSection';
import Contact from './components/Contact';
import About from './components/about/About';
import Main from './components/ai/Main'
import ProductPortfolio from './components/portfolio/PortfolioSection';
import PortfolioPage from './components/portfolio/PortfolioPage';
import Customer from './components/footer/Customer';
import Terms from './components/footer/Terms';
import Privacy from './components/footer/Privacy';
import ScrollToTop from "./components/ScrollTop";
function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Home Page */}
        <Route
          path="/"
          element={
            <>
              <Landing />
              <ProductSection />
              <Client />
              <Provide />
              <Testimonial />
              <Faq />                                  
              <Footer />
            </>
          }
        />
 <Route path='/contact' element={<Contact /> } />
  <Route path='/about' element={<About /> } />
  <Route path='/ai' element={<Main /> } />
  <Route path='/portfolio' element={<ProductPortfolio /> } />
    <Route path='/portfolio-details/:id' element={<PortfolioPage /> } />
         <Route path='/customer' element={<Customer /> } />
         <Route path='/terms' element={<Terms /> } />
         <Route path='/privacy' element={<Privacy /> } />
        {/* Product Detail Page */}
        <Route path="/product/:id" element={<ProductDetail />} />
      </Routes>
    </Router>
  );
}

export default App;
